import { AppButton } from 'components/form';
import Dialog from '@mui/material/Dialog';
import React from 'react';
import { t } from 'i18next';

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}
interface AppErrorBoundaryState {
  hasError: boolean;
}

// ErrorBoundary that will catch any errors that occur in the app
// and display a friendly error message to the user.
// This is a good place to log errors to a service like Sentry.
export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <Dialog
            maxWidth={'md'}
            fullWidth
            className={`app-error-boundary`}
            open={true}
            onClose={() => {}}
            data-test='app-error-boundary-dialog'
          >
            <header className='border-0 mb-0 text-center text-white bg-dark py-3'>
              <h3 className='font-22 font-500 text-uppercase mb-0 text-uppercase font-22 font-500'>{t('errorText') as string}</h3>
            </header>
            <div className='body card-body text-center p-3 font-20 d-flex flex-column align-items-center'>
              <p>{t('something_went_wrong_please_refresh_the_page') as string}</p>
              <p>{t('if_the_problem_persists_please_contact_support') as string}</p>
              <AppButton className='mt-3' onClick={window.location.reload}>
                {t('refresh') as string}
              </AppButton>
            </div>
          </Dialog>
        </div>
      );
    }

    return this.props.children;
  }
}
